/*
 *
 * OperationDCC
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 10-Mar-2025
 */

import { connect } from 'react-redux'
import OperationDCC from './OperationDCC'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  info: state.operations?.operation?.additionalData || null,
  isLoading: state.loading.local_OperationDetails || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationDCC)
